import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { UitkCard, UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkEmptyState } from 'uitk-react-empty-state';

@withLocalization
export class NoReviews extends React.Component<LocalizedComponentProps> {
  constructor(props) {
    super(props);
  }

  public render(): JSX.Element {
    const { l10n } = this.props;

    return (
      <UitkCard>
        <UitkCardContent>
          <UitkCardTextSegment>
            <UitkEmptyState
              icon="comment"
              heading={l10n.formatText('hotels.infosite.reviews.noReviewsYet')}
              body={l10n.formatText('hotels.infosite.reviews.seeYourReviewHere')}
              headingLevel="h2"
            />
          </UitkCardTextSegment>
        </UitkCardContent>
      </UitkCard>
    );
  }
}
